module.exports = __webpack_public_path__ + "static/B_Cover-66fae666953e192d59eb74478ed3ac51.webp";